import { IAppAction } from 'smarthub-common'

export const actions: IAppAction[] = []
